'use strict';

// Constructor
var SearchListing = function () {
    
};

module.exports = SearchListing;
